"use client";

import {useContext, useState} from "react";
import {Basket} from "../../../context/basket";
import getSha1 from '../../../utils/sha1';

const ImpactIdentity = () => {
    const [loaded, setLoaded] = useState(false);
    const basket = useContext(Basket);

    if (loaded === false
        && typeof window !== 'undefined'
        && typeof ire !== 'undefined'
        && typeof basket?.data?.quote?.quote?.uuid !== 'undefined') {
        const basketData = basket?.data?.quote?.quote;

        let data = {
            customerId: '',
            customerEmail: '',
            customProfileId: basketData.uuid
        };

        // Execute via SHA-1 encryption if logged in.
        if (typeof basketData.customer_email !== 'undefined') {
            data.customerId = basketData.customer_id;
            getSha1(basketData.customer_email)
                .then(hash => hash)
                .then(hash => {
                    data.customerEmail = hash;
                    ire('identify', data);
                }
            );
        } else {
            // Otherwise logged out with UUID.
            ire('identify', data);
        }

        setLoaded(true);
    }
};

export default ImpactIdentity;